import { getPermissions } from "@/helper/collection";
import store from "@/store";

export const MyCinemaRoutes = {
  path: "/mycinemas",
  name: "My Cinemas",
  GogoName: "On Demand",
  redirect: "/mycinemas",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () => import("@/components/MyCinemas/CategoryHome.vue"),
      meta: {},
    },
    {
      path: "categories",
      name: "list Category",
      component: () =>
        import("@/components/MyCinemas/Category/ListCategory.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          167,
          2
        ),
      },
    },
    {
      path: "add-category",
      name: "Add Category",
      component: () =>
        import("@/components/MyCinemas/Category/AddCategory.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          167,
          2
        ),
      },
    },
    {
      path: "edit-category",
      name: "Edit Category",
      component: () =>
        import("@/components/MyCinemas/Category/EditCategory.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          167,
          2
        ),
      },
    },
    {
      path: "view-category",
      name: "View Category",
      component: () =>
        import("@/components/MyCinemas/Category/ViewCategory.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          167,
          2
        ),
      },
    },
    {
      path: "myfestival-movies",
      name: "MyFestival Movies",
      component: () =>
        import(
          "@/components/MyCinemas/CategoryLinkMovie/ListCategoryLinkMovie.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          168,
          2
        ),
      },
    },
    {
      path: "edit-myfestival-movie",
      name: "Edit MyFestival Movie",
      component: () =>
        import(
          "@/components/MyCinemas/CategoryLinkMovie/EditCategoryLinkMovie.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          168,
          2
        ),
      },
    },
    {
      path: "add-myfestival-movie",
      name: "Add MyFestival Movie",
      component: () =>
        import(
          "@/components/MyCinemas/CategoryLinkMovie/AddCategoryLinkMovie.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          168,
          2
        ),
      },
    },
    {
      path: "daily-sales-report",
      name: "MyCinema Daily Sales Report",
      GogoName: "On Demand Daily Sales Report",
      component: () =>
        import("@/components/MyCinemas/Reports/dailySalesReportMycinema"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          192,
          1
        ),
      },
    },
    {
      path: "transaction-report",
      name: "Transaction Report",
      component: () =>
        import("@/components/MyCinemas/Reports/transactionsReports"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          191,
          1
        ),
      },
    },
    {
      path: "cms",
      name: "CMS",
      component: () => import("@/components/MyCinemas/CMS/addCMS"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          187,
          1
        ),
      },
    },
    {
      path: "ondemand-cinema-setting",
      name: "OnDemand Master Cinema Setting",
      component: () =>
        import(
          "@/components/MyCinemaComponents/MultiScheduling/OnDemandSetting"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          190,
          1
        ),
      },
    },

    {
      path: "advertise-with-us",
      name: "Advertise With Us",
      component: () => import("@/components/MyCinemas/AdvertisewithUs"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          304,
          1
        ),
      },
    },

    {
      path: "add-edit-advertise-with-us",
      name: "Add | Edit Advertise With Us",
      component: () => import("@/components/MyCinemas/addAdvertisewithus"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          304,
          1
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/myCinemaRoutes.js